import { renderPrintDocument } from "../../core/renderPrintDocument";
import { escapeHtml } from "../../shared/escapeHtml";
import { officialDocumentStyles } from "../../shared/officialDocumentStyles";
import { createPumpStatementPrintViewModelV2 } from "./createPumpStatementPrintViewModelV2";

const pumpStatementStylesV2 = `
  ${officialDocumentStyles}
`;

const renderPumpStatementBody = (model, t) => `
  <main class="official-document">
    <header class="official-header">
      <div class="official-logo-wrap">
        ${
          model.companyLogo
            ? `<img src="${escapeHtml(model.companyLogo)}" alt="Company logo" class="official-logo" />`
            : ""
        }
      </div>
      <div class="official-header-main">
        <h1 class="official-vessel-name">${escapeHtml(model.vesselName)}</h1>
        <h2 class="official-title">${escapeHtml(model.title)}</h2>
      </div>
    </header>

    <hr class="official-rule" />

    <table class="official-meta" aria-label="Document metadata">
      <tbody>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.receivers"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.receiverName)}</td>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.port"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.portName)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">Voyage No.:</td>
          <td class="official-meta-value">${escapeHtml(model.voyageNumber)}</td>
          <td class="official-meta-label">From:</td>
          <td class="official-meta-value">${escapeHtml(model.fromPort)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">To:</td>
          <td class="official-meta-value">${escapeHtml(model.toPort)}</td>
          <td class="official-meta-label"></td>
          <td class="official-meta-value"></td>
        </tr>
      </tbody>
    </table>

    <hr class="official-meta-separator" />

    <section class="official-section">
      <p class="official-paragraph">
        <span class="official-emphasis">Please note that the maximum pressure you are allowed to maintain on the manifold of your vessel's rail is:</span>
        ${escapeHtml(model.maxPressure)}
      </p>
      <p class="official-paragraph">
        <span class="official-emphasis">And a maximum discharge rate of:</span>
        ${escapeHtml(model.maxRate)}
      </p>
    </section>

    <section class="official-receipt">
      <div class="official-receipt-grid">
        <span class="official-receipt-label">Date:</span>
        <span class="official-line"></span>
      </div>
      <p class="official-paragraph"><span class="official-emphasis">Loading master:</span></p>
    </section>

    <section class="official-section">
      <p class="official-paragraph">
        <span class="official-emphasis">We confirm that you during the discharge have maintained:</span>
      </p>
      <div class="official-receipt-grid">
        <span class="official-receipt-label">A pressure of:</span>
        <span class="official-line"></span>
      </div>
      <div class="official-receipt-grid">
        <span class="official-receipt-label">A discharge rate of:</span>
        <span class="official-line"></span>
      </div>
    </section>

    <section class="official-signatures">
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">Loading master</div>
      </div>
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">Name in block</div>
      </div>
    </section>
  </main>
`;

export const renderPumpStatementV2 = (input) => {
  const model = createPumpStatementPrintViewModelV2(input);

  return renderPrintDocument({
    title: model.title,
    templateId: "pump-statement",
    viewModel: model,
    styles: pumpStatementStylesV2,
    body: renderPumpStatementBody(model, input.t),
  });
};
